import type { GeojsonEditorProps } from "./geojson-editor.type";

import { Editor } from "@monaco-editor/react";

import { useGeoJsonEditor } from "./geojson-editor.hook";

const GeojsonEditor = ({ value, onChange, onError }: GeojsonEditorProps) => {
  const { geoJson, handleChange, handleEditorDidMount } = useGeoJsonEditor({
    value,
    onChange,
    onError,
  });

  return (
    <Editor
      onChange={handleChange}
      defaultValue={geoJson}
      defaultLanguage="json"
      height="250px"
      onMount={handleEditorDidMount}
      options={{
        minimap: { enabled: false },
        lineNumbers: "off",
        suggestOnTriggerCharacters: false,
        quickSuggestions: false,
        parameterHints: { enabled: false },
        wordBasedSuggestions: "off",
        tabCompletion: "off",
      }}
    />
  );
};

export default GeojsonEditor;
